import React from "react";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import { useSelector } from "react-redux";

function ViewDocuments(props) {
  const roleType = useSelector(
    (state) => state?.auth?.checkLogin?.dto?.loggedInRoleType
  );

  const isRMOrCET = roleType === "RM" || roleType === "CET";

  let companyDocuments = props?.Master?.companyDocumentsList;

  let signatoryDocuments = props?.Master?.partnerSignatoryDocumentsList;

  let partnerDocs = props?.Master?.partnerDocumentsList;

  let docs = props?.docs?.showDocuments?.dtoList;

  const partnerPayoutDocumentsList =
    props?.Master?.allDocuments?.partnerPayoutDocumentsList;

  return (
    <div className="inner-Tab-sec-edit-pat">
      <Tab.Container
        id="left-tabs-example"
        className="left-tabs-example"
        defaultActiveKey="first"
      >
        <Row>
          <Col sm={2} className="left-side-tabs branchScroll">
            <Nav variant="pills" className="flex-column left-side-tabs-scroll">
              <Nav.Item>
                <Nav.Link eventKey="first">
                  <div className="tab-selet-test">
                    <h4>Company Documents</h4>
                  </div>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="second">
                  <div className="tab-selet-test">
                    <h4>Signatory Documents</h4>
                  </div>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="third">
                  <div className="tab-selet-test">
                    <h4>Team Documents</h4>
                  </div>
                </Nav.Link>
              </Nav.Item>
              {isRMOrCET ? (
                <Nav.Item>
                  <Nav.Link eventKey="four">
                    <div className="tab-selet-test">
                      <h4>Partner Payout Documents</h4>
                    </div>
                  </Nav.Link>
                </Nav.Item>
              ) : null}
            </Nav>
          </Col>
          <Col sm={10}>
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="ineer-ed-text tabs-sec"
                  >
                    <Col md={6} className="">
                      <div className="text-content-ed">
                        {companyDocuments?.map((el) => {
                          return (
                            <>
                              <h5>{el?.partnerDocumentTypeName}</h5>
                              <ul>
                                {docs
                                  ?.filter((i) => {
                                    return (
                                      i.section == el.section &&
                                      i.partnerDocumentTypeId ==
                                        el.partnerDocumentTypeId
                                    );
                                  })
                                  ?.map((item) => {
                                    return (
                                      <li>
                                        <a
                                          target="_blank"
                                          href={item.documentLink}
                                        >
                                          {item.fileName}
                                        </a>
                                      </li>
                                    );
                                  })}
                              </ul>
                            </>
                          );
                        })}
                      </div>
                    </Col>
                  </Col>
                </Row>
              </Tab.Pane>
              <Tab.Pane eventKey="second">
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="ineer-ed-text tabs-sec"
                  >
                    <Col md={6} className="">
                      <div className="text-content-ed">
                        {signatoryDocuments?.map((el) => {
                          return (
                            <>
                              <h5>{el?.partnerDocumentTypeName}</h5>
                              <ul>
                                {docs
                                  ?.filter((i) => {
                                    return (
                                      i.section == el.section &&
                                      i.partnerDocumentTypeId ==
                                        el.partnerDocumentTypeId
                                    );
                                  })
                                  ?.map((item) => {
                                    return (
                                      <li>
                                        <a
                                          target="_blank"
                                          href={item.documentLink}
                                        >
                                          {item.fileName}
                                        </a>
                                      </li>
                                    );
                                  })}
                              </ul>
                            </>
                          );
                        })}
                      </div>
                    </Col>
                  </Col>
                </Row>
              </Tab.Pane>
              <Tab.Pane eventKey="third">
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="ineer-ed-text tabs-sec"
                  >
                    <Col md={6} className="function-sec">
                      <div className="text-content-ed">
                        {partnerDocs.map((el) => {
                          return (
                            <div>
                              <h5>{el.partnerTeamName}</h5>
                              <div className="Documents">
                                {el?.partnerTeamDocumentsList?.map((item) => {
                                  return (
                                    <div className="Document">
                                      <h5>{item.partnerDocumentTypeName}</h5>
                                      {
                                        <ul>
                                          {docs
                                            ?.filter((e) => {
                                              return (
                                                e.partnerDocumentTypeId ==
                                                item.partnerDocumentTypeId
                                              );
                                            })
                                            .map((p) => {
                                              return (
                                                <li>
                                                  <a
                                                    target="_blank"
                                                    href={p.documentLink}
                                                  >
                                                    {p.fileName}
                                                  </a>
                                                </li>
                                              );
                                            })}
                                        </ul>
                                      }
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </Col>
                  </Col>
                </Row>
              </Tab.Pane>
              {isRMOrCET ? (
                <Tab.Pane eventKey="four">
                  <Row>
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      className="ineer-ed-text tabs-sec"
                    >
                      <Col md={6}>
                        <div className="text-content-ed">
                          <h5>Partner Payout Documents</h5>
                          {partnerPayoutDocumentsList?.map((el) => {
                            const matchingDocs = docs?.filter(
                              (doc) =>
                                doc.section === el.section &&
                                doc.partnerDocumentTypeId ===
                                  el.partnerDocumentTypeId
                            );

                            return (
                              <div
                                key={el.partnerDocumentTypeId}
                                style={{ marginBottom: "20px" }}
                              >
                                <h6>{el.dmsDocTypeName}</h6>
                                {matchingDocs?.length > 0 ? (
                                  <ul style={{ paddingLeft: "16px" }}>
                                    {matchingDocs.map((doc) => (
                                      <li key={doc.documentId}>
                                        <a
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          href={doc.documentLink}
                                        >
                                          {doc.fileName}
                                        </a>
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  <p>No documents uploaded.</p>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </Col>
                    </Col>
                  </Row>
                </Tab.Pane>
              ) : null}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
}

export default ViewDocuments;
